const $ = require('jquery');

function whichTransitionEvent(transitions) {
    let t;
    const el = document.createElement('fakeelement');
    for (t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }

    return undefined;
}

const endTransitions = {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
};

const endEvent = whichTransitionEvent(endTransitions);

module.exports = {
    onTransitionEnd(element, callback) {
        const $element = typeof element === $ ? element : $(element);
        if (endEvent !== undefined) {
            $element.off(endEvent).one(endEvent, callback);
        } else {
            callback();
        }
    }
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/transition/transition-events.js
 **/